export default class Pagination {
  static get URL_PARAM_PAGE() {
    return 'page'
  }

  static get URL_PARAM_LIMIT() {
    return 'limit'
  }

  static get LIMIT_ALL() {
    return 'all'
  }

  static get DEFAULT_LIMIT() {
    return 100
  }

  static get DEFAULT_PAGE() {
    return 1
  }

  constructor(criteria) {
    this._page = Pagination.DEFAULT_PAGE
    this._limit = Pagination.DEFAULT_LIMIT
    this._criteria = criteria

    if (this._criteria) {
      this.parseCriteria()
    }
  }

  parseCriteria() {
    /* eslint-disable no-useless-escape */
    const paramPage = this._criteria.match(
      new RegExp(`${Pagination.URL_PARAM_PAGE}=(.+?)\/`, 'i'),
    )
    const paramLimit = this._criteria.match(
      new RegExp(`${Pagination.URL_PARAM_LIMIT}=(.+?)\/`, 'i'),
    )
    /* eslint-enable no-useless-escape */

    if (paramPage && paramPage[1]) {
      this._page = Math.abs(parseInt(paramPage[1], 10))
    }

    if (paramLimit && paramLimit[1]) {
      this._limit = Math.abs(parseInt(paramLimit[1], 10))
    }
  }

  getPagination() {
    return {
      page: this.page,
      limit: this.limit,
    }
  }

  clearPagination() {
    this._page = Pagination.DEFAULT_PAGE
    this._limit = Pagination.DEFAULT_LIMIT
  }

  get page() {
    return this._page
  }

  get limit() {
    return this._limit
  }

  setPagination(page, limit) {
    this.setLimit(limit)
    this.setPage(page)
  }

  setPage(page) {
    this._page = Math.abs(parseInt(page, 10))
  }

  setLimit(limit) {
    this._limit =
      limit !== Pagination.LIMIT_ALL ? Math.abs(parseInt(limit, 10)) : limit
  }

  getCriteria() {
    const pagPage =
      this._page && this._page !== Pagination.DEFAULT_PAGE
        ? `${Pagination.URL_PARAM_PAGE}=${this._page}/`
        : ''
    const pagLimit = this._limit
      ? `${Pagination.URL_PARAM_LIMIT}=${this._limit}/`
      : ''

    return pagPage + pagLimit
  }

  getApiCriteria(displayOptions) {
    if (displayOptions && !displayOptions.paginationParamsEnabled) {
      return ''
    }

    const pagPage =
      this._page && this._page !== Pagination.DEFAULT_PAGE
        ? `${Pagination.URL_PARAM_PAGE}=${this._page}`
        : ''
    const pagLimit = this._limit
      ? `${Pagination.URL_PARAM_LIMIT}=${this._limit}`
      : ''

    return pagPage + (pagPage ? '&' : '') + pagLimit
  }
}
